var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppPlusChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 32,
    viewBox: "0 0 74 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 26C12 24.9375 11.0625 24 10 24C8.875 24 8 24.9375 8 26C8 27.125 8.875 28 10 28C11.0625 28 12 27.125 12 26ZM20 3C20 1.375 18.625 0 17 0H3C1.3125 0 0 1.375 0 3V29C0 30.6875 1.3125 32 3 32H17C18.625 32 20 30.6875 20 29V3ZM18 3V29C18 29.5625 17.5 30 17 30H3C2.4375 30 2 29.5625 2 29V3C2 2.5 2.4375 2 3 2H17C17.5 2 18 2.5 18 3ZM68.5 22H69.5C69.75 22 70 21.8125 70 21.5V6.5C70 6.25 69.75 6 69.5 6H68.5C68.1875 6 68 6.25 68 6.5V21.5C68 21.8125 68.1875 22 68.5 22ZM62.5 22H63.5C63.75 22 64 21.8125 64 21.5V12.5C64 12.25 63.75 12 63.5 12H62.5C62.1875 12 62 12.25 62 12.5V21.5C62 21.8125 62.1875 22 62.5 22ZM50.5 22H51.5C51.75 22 52 21.8125 52 21.5V16.5C52 16.25 51.75 16 51.5 16H50.5C50.1875 16 50 16.25 50 16.5V21.5C50 21.8125 50.1875 22 50.5 22ZM56.5 22H57.5C57.75 22 58 21.8125 58 21.5V8.5C58 8.25 57.75 8 57.5 8H56.5C56.1875 8 56 8.25 56 8.5V21.5C56 21.8125 56.1875 22 56.5 22ZM73.5 26H44V4.5C44 4.25 43.75 4 43.5 4H42.5C42.1875 4 42 4.25 42 4.5V27C42 27.5625 42.4375 28 43 28H73.5C73.75 28 74 27.8125 74 27.5V26.5C74 26.25 73.75 26 73.5 26ZM30.25 15.75H33.625C33.8125 15.75 34 15.9375 34 16.125V16.875C34 17.0859 33.8125 17.25 33.625 17.25H30.25V20.625C30.25 20.8359 30.0625 21 29.875 21H29.125C28.9141 21 28.75 20.8359 28.75 20.625V17.25H25.375C25.1641 17.25 25 17.0859 25 16.875V16.125C25 15.9375 25.1641 15.75 25.375 15.75H28.75V12.375C28.75 12.1875 28.9141 12 29.125 12H29.875C30.0625 12 30.25 12.1875 30.25 12.375V15.75Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppPlusChart);
export default __webpack_public_path__ + "static/media/app_plus_chart.ec7777d5c540397d378e5f0b9d00ac81.svg";
export { ForwardRef as ReactComponent };